var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dotted i",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7329 11.5325L22.3676 14.026V20.5091L18.0024 23.0338L13.6371 20.5091V9.00779L20.4968 5.04935L18.0024 3.58441L11.1426 7.54285V21.9428L18.0024 25.9013L24.8621 21.9428V15.4909L33.5926 10.4416V26.9922L18.0024 36L2.41211 26.9922V9.00779L5.53016 7.2V25.1844L18.0024 32.3844L30.4745 25.1844V15.8338L27.9801 17.2675V23.7506L18.0024 29.5169L8.0246 23.7506V5.76623L18.0024 0L26.7329 5.04935L16.7551 10.7844V18.7013L18.0024 19.4493L19.2496 18.7013V12.2493L23.6148 9.72467L26.7329 11.5325ZM32.3454 8.29091L29.2273 10.0675L26.1093 8.29091L29.2273 6.48311L32.3454 8.29091Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingLogo);
export default __webpack_public_path__ + "static/media/brandingLogo.05fe5ed3e445df522f691a6070a0d124.svg";
export { ForwardRef as ReactComponent };